import { GridRowId } from '@mui/x-data-grid';
import { createAsyncThunk } from '@reduxjs/toolkit';

import { handleListFetch } from '../apiHelpers';
import { APISuiteGet } from '../ApplicationSuites/ApplicationSuites.api';
import { APISuiteGetResponse } from '../ApplicationSuites/ApplicationSuitesApiTypeDefs';
import { APITenantGetResponse } from '../Tenants/TenantApiTypeDefs';
import { APITenantGet } from '../Tenants/Tenants.api';

import { APILicenseGetResponse, APILicensesPostParams, APILicensesPutParams } from './LicenseApiTypeDef';
import {
    APILicenseDelete,
    APILicenseGet,
    APILicensePut,
    APILicensesGet,
    APILicensesPost } from './Licenses.api';
import { _formatLicenseDetailsResponse, _formatLicenseResponse } from './LicenseThunkHelpers';

export const fetchLicenses = createAsyncThunk( 'licenses/fetchLicenses', async (item: { tenantId: string, signal?: AbortSignal })=> {
    const response = await APILicensesGet(item);
    return _formatLicenseResponse(response.data);
});

export const fetchLicense = createAsyncThunk( 'licenses/fetchLicense', async (item: { tenantId: string, id: string })=> {
    const response = await APILicenseGet(item);
    return response.data;
});

export const fetchLicenseDetails = createAsyncThunk('licenseDetails/fetchDetails', async (item: {applicationSuiteId: string, tenantId: string, licenseId: string}) => {
    const requests = [
        APISuiteGet({ id: item.applicationSuiteId }),
        APITenantGet({ id: item.tenantId }),
        APILicenseGet({ id: item.licenseId , tenantId: item.tenantId })
    ];

    const responses = await Promise.all(requests);

    const suiteResponse = responses[0] as APISuiteGetResponse;
    const tenantResponse = responses[1] as APITenantGetResponse;
    const licenseDetailsResponse = responses[2] as APILicenseGetResponse;

    return _formatLicenseDetailsResponse(suiteResponse, tenantResponse, licenseDetailsResponse);
});

export const postLicense = createAsyncThunk('licenses/postLicense', async (item : APILicensesPostParams) => {
    const response = await APILicensesPost(item);
    const rows = _formatLicenseResponse(await handleListFetch(APILicensesGet({ tenantId: item.tenantId })));
    return {
        item,
        response,
        rows
    };
});

export const putLicense = createAsyncThunk('licenses/putLicense', async (item : APILicensesPutParams) => {
    const response = await APILicensePut(item);
    const rows = _formatLicenseResponse(await handleListFetch(APILicensesGet({ tenantId: item.tenantId })));
    return {
        item,
        response,
        rows
    };
});

export const deleteLicense = createAsyncThunk('licenses/deleteLicense', async (item: { tenantId: string, licenseId: GridRowId }) => {
    const response = await APILicenseDelete({ id: item.licenseId, tenantId: item.tenantId });
    const rows = _formatLicenseResponse(await handleListFetch(APILicensesGet({ tenantId: item.tenantId })));
    return {
        item,
        response,
        rows
    };
});
